// extracted by mini-css-extract-plugin
export default {"container":"h1-z","list":"i1-z"};